import React, { useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { setSoundAction, playSoundAction, clearSoundAction } from "../../../../../redux/sound";
import PopupTrigger from "../../../../common/PopupTrigger";
import Button from "../../../../common/Button";

const TimeOverPopup = props => <PopupTrigger onClose={ props.onHide }><Popup /></PopupTrigger>;

const Popup = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setSound = payload => { dispatch( setSoundAction( payload ) ) };
  const playSound = () => { dispatch( playSoundAction() ) };
  const clearSound = () => { dispatch( clearSoundAction() ) };

  const { t } = useTranslation();

  useEffect( () => {
    switch ( answeringQuestions.timeOverLevel ) {
      case 1 :
        setSound( { src : `${ process.env.PUBLIC_URL }/static/audio/lc_05_15_whistle.ogg` } );
        break;
      case 2 :
        setSound( { src : `${ process.env.PUBLIC_URL }/static/audio/lc_05_15_timer.ogg` } );
        break;
    }
    playSound();
    return () => {
      setTimeout( clearSound );
    };
  }, [ answeringQuestions.timeOverLevel ] );

  const message = useMemo( () => {
    switch ( answeringQuestions.timeOverLevel ) {
      case 1 :
        return t( 'LC_05_20.msg012' );
      case 2 :
        return t( 'LC_05_20.msg013' );
    }
  }, [ answeringQuestions.timeOverLevel ] );

  return (
    <div className="lp-container lc-alert lc-def m_border0">
      <div className="ico_clock type2" />
      <p className="lc-alert_txt fwm mt0" dangerouslySetInnerHTML={ { __html : message } } />
      <div className="lp-btnBox mt40">
        <Button className="btn btn-blue" onClick={ props.onHide }>{t( 'LC_05_20.msg022' )}</Button>
      </div>
    </div>
  );

};

export default TimeOverPopup;
